import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"

import BuildInformation from "./BuildInformation";
import Auth from "./pages/Auth";
import RaceEntry from "./pages/RaceEntry";
import Roster from "./pages/Roster";
import GrandPrixEntry from "./pages/GrandPrixEntry";
import GrandPrixRaceEntry from "./pages/GrandPrixRaceEntry";
import Homepage from "./pages/Homepage";
import NotFoundPage from "./pages/NotFoundPage";
import StatsCourses from "./pages/StatsCourses";
import StatsGrandPrix from "./pages/StatsGrandPrix";
import StatsMain from "./pages/StatsMain";
import StatsPlayers from "./pages/StatsPlayer";

import PrivateRoute from "./utilComponents/PrivateRoute";
import NavBar from "./utilComponents/NavBar";

import { ThemeProvider } from '@mui/material/styles';

import { mk_theme } from "./styles/mk_theme";


function App() {

  return (
    <Router>
      <ThemeProvider theme={mk_theme}>
        <NavBar />
        <div className="background-image"></div>
        <link href="https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap" rel="stylesheet"/>
        <Routes>
          <Route path="/" element={<PrivateRoute><Homepage /></PrivateRoute>} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/roster" element={<PrivateRoute> <Roster /> </PrivateRoute>} />
          <Route path="/raceentry" element={<PrivateRoute><RaceEntry /></PrivateRoute>} />
          <Route path="/grandprix" element={<PrivateRoute><GrandPrixEntry /></PrivateRoute>} />
          <Route path="/grandprix/:id" element={<PrivateRoute><GrandPrixRaceEntry /></PrivateRoute>} />
          <Route path="/stats" element={<StatsMain />} />
          <Route path="/stats/courses/:id" element={<StatsCourses />} />
          <Route path="/stats/grandprix/:id" element={<StatsGrandPrix />} />
          <Route path="/stats/players/:id" element={<StatsPlayers />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <BuildInformation />

      </ThemeProvider>
    </Router>
  );
}

export default App;
